/*
 * yodaSiteComponents registry entries for this microsite.
 *
 * Page-level entries (IrisPage, Loading) are this microsite's own concern.
 * The externalized shell set (header/footer/sliders, PM-312) comes from the
 * shared fragment in yoda-app-shell so every microsite carries the identical
 * definition.
 */
const {
    getExternalizedShellRegistry,
} = require('yoda-app-shell/lib/mfe/externalMfComponents');

const yodaSiteComponents = {
    IrisPage: {
        importFn: () => import('yodaSiteComponents/IrisPage'),
        path: 'yodaSiteComponents/IrisPage',
        type: 'class',
        isSSR: true,
    },
    Loading: {
        importFn: () => import('yodaSiteComponents/Loading'),
        path: 'yodaSiteComponents/Loading',
        type: 'class',
        isSSR: false,
    },
    ...getExternalizedShellRegistry(),
};

module.exports = { yodaSiteComponents };
